import { useContext } from "react";
import { SupabaseProvider } from "./main";

export const useSupabase = () => {
  const context = useContext(SupabaseProvider);
  if (context === null) {
    throw new Error("useSupabase must be used within a SupabaseProvider");
  }
  return context;
};
